export class UserDto {
    public id: number;
    public userId?: number;
    public userName?: string;
    public email?: string;
    public firstName?: string;
    public lastName?: string;
    public retailers: Array<any>;
    public roleId: number;
    public roleName: string;
    public allRetailers: boolean;
    public dashBoardDescription: string;
    public dashboardId: number;

    constructor() {
        this.retailers = new Array<any>();
    }
}
export class UserRetailerListItemDto {
    public Id: number;
    public UserId: number;
    public RetailerId: number;
    public BudgetYear: number;
    public RetailerName: string;
}

export interface CampaignThemeFavoriteListItemDto {
    id: number,
    userId?: number,
    themeId?: number,
    themeDocumentId?: number,
    themeName?: string,
    themeShortDescription?: string,
    themeLongDescription?: string,
    startDate: Date,
    endDate: Date
}

export interface CampaignThemeRecomendedListItemDto {
    id: number,
    userId?: number,
    themeId?: number,
    themeDocumentId?: number,
    themeName?: string,
    themeShortDescription?: string,
    themeLongDescription?: string,
    startDate: Date,
    endDate: Date
}

export interface TacticFavoriteListItemDto {
    tacticProductTypeId: number;
    id: number,
    userId?: number,
    tacticId?: number,
    tacticTacticName?: String
    tacticTacticDesc?: string
    tacticdocumentId?: number
    tacticTacticProductionOptionId?: number,
    tacticFlatCost?: number,
    tacticMinimumQuantity?: number,
    tacticMaximumQuantity?: number
}

export interface Claim {
    resource: string,
    operation: string
}

export interface SiteConfig {
    configuration: string,
    operation: string,
    displayName: string;
}



// WEBPACK FOOTER //
// ./src/app/client-core/dtos/users.model.ts